module.exports = __webpack_public_path__ + "img/rec.4d8714cb.webp";